document.addEventListener("DOMContentLoaded", () => {
  /* ========== pagetop button ========== */
  const pagetop = document.getElementById("c_pagetop");
  const trigger = document.getElementById("c_pagetop-trigger");

  if (pagetop && trigger) {
    function togglePageTop() {
      const triggerTop = trigger.getBoundingClientRect().top;

      if (triggerTop <= window.innerHeight) {
        pagetop.classList.add("is-show");
      } else {
        pagetop.classList.remove("is-show");
      }
    }

    window.addEventListener("scroll", togglePageTop);
    togglePageTop();
  }

  /* ========== video volume on/off ========== */
  const fvSections = document.querySelectorAll(".c_fv");

  fvSections.forEach((section) => {
    const videos = section.querySelectorAll(
      ".c_fv-movie-sp, .c_fv-movie-pc"
    );
    const button = section.querySelector(".c_volume-btn");

    if (!button || !videos.length) return;

    button.addEventListener("click", () => {
      // 現在表示されている動画を取得
      const video = [...videos].find(
        (video) => getComputedStyle(video).display !== "none"
      );

      if (!video) return;

      if (video.muted) {
        // このページ内の動画をすべてミュート
        document
          .querySelectorAll(".c_fv-movie-sp, .c_fv-movie-pc")
          .forEach((v) => {
            v.muted = true;
          });

        // この動画だけ音声ON
        video.muted = false;
        video.play();

        // このボタンだけON状態
        button.classList.remove("is-muted");
        button.setAttribute("aria-label", "音声をオフにする");
      } else {
        // 音声OFF
        video.muted = true;

        button.classList.add("is-muted");
        button.setAttribute("aria-label", "音声をオンにする");
      }
    });
  });


  /* ========== 画面外に出たら自動ミュート ========== */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          const section = entry.target;

          // このセクション内の動画をミュート
          section
            .querySelectorAll(".c_fv-movie-sp, .c_fv-movie-pc")
            .forEach((video) => {
              video.muted = true;
            });

          // ボタンもOFF状態に戻す
          const button = section.querySelector(".c_volume-btn");

          if (button) {
            button.classList.add("is-muted");
            button.setAttribute("aria-label", "音声をオンにする");
          }
        }
      });
    },
    {
      threshold: 0.3,
    }
  );

  fvSections.forEach((section) => {
    observer.observe(section);
  });

  /* ========== img slide ========== */
  const tracks = document.querySelectorAll(".c_cm__gallery-track");

  let current = 0;
  const total = 2;

  function slideNext() {
    current++;

    if (current >= total) {
      current = 0;
    }

    tracks.forEach((track) => {
      track.style.transition = "transform 0.6s ease";
      track.style.transform = `translateX(-${current * 100}%)`;
    });
  }

  if (tracks.length) {
    setInterval(slideNext, 3000);
  }

  /* ========== fade up ========== */
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray(".c_fade-up").forEach((el) => {
    gsap.fromTo(
      el,
      {
        opacity: 0,
        y: 40,
      },
      {
        opacity: 1,
        y: 0,
        duration: 2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true,
        },
      },
    );
  });

  /* ========== interview fade up ========== */
  gsap.utils.toArray(".c_interview__inner.c_fade-up").forEach((el) => {
    gsap.fromTo(
      el,
      {
        opacity: 0,
        y: 40,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true,
        },
      },
    );
  });

  /* ========== fade up stagger ========== */
  gsap.utils
    .toArray(".c_overview__block-textcontainer")
    .forEach((container) => {
      gsap.fromTo(
        container.querySelectorAll(".c_fade-up-stagger"),
        {
          opacity: 0,
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.5,
          ease: "power2.out",
          stagger: 0.5,
          scrollTrigger: {
            trigger: container,
            start: "top 80%",
            once: true,
          },
        },
      );
    });
});
